import posthog from 'posthog-js'

import { ITracker } from '@/store/spi/tracker.ts'
import { CaseWorker, Organization } from '@/store/user'

export class PostHogTracker implements ITracker {
  public client: typeof posthog
  constructor() {
    posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
      api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
      autocapture: false,
      defaults: '2025-05-24',
    })
    this.client = posthog
  }
  identify({
    caseWorker,
    organization,
  }: {
    caseWorker: CaseWorker
    organization: Organization
  }): void {
    posthog.identify(caseWorker.id, {
      email: caseWorker.email,
    })
    posthog.group('organization', organization.id, {
      id: organization.id,
      name: organization.name,
      hasStructuredData: organization.structuredDataSchema.length > 0,
      // FIXME: features: JSON.stringify(organization.features),
    })
  }

  track({ event }: { event: string }): void {
    posthog.capture(event)
  }
}
